module.exports = __webpack_public_path__ + "static/hand@2x-05af8cd20419f08bd0f5f829303831af.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/share/hand@2x.png
// module id = 924
// module chunks = 37722542382512 271422636699454